const _temp0 = require("../../intl/dropzone/ar-AE.json");
const _temp1 = require("../../intl/dropzone/bg-BG.json");
const _temp2 = require("../../intl/dropzone/cs-CZ.json");
const _temp3 = require("../../intl/dropzone/da-DK.json");
const _temp4 = require("../../intl/dropzone/de-DE.json");
const _temp5 = require("../../intl/dropzone/el-GR.json");
const _temp6 = require("../../intl/dropzone/en-US.json");
const _temp7 = require("../../intl/dropzone/es-ES.json");
const _temp8 = require("../../intl/dropzone/et-EE.json");
const _temp9 = require("../../intl/dropzone/fi-FI.json");
const _temp10 = require("../../intl/dropzone/fr-FR.json");
const _temp11 = require("../../intl/dropzone/he-IL.json");
const _temp12 = require("../../intl/dropzone/hr-HR.json");
const _temp13 = require("../../intl/dropzone/hu-HU.json");
const _temp14 = require("../../intl/dropzone/it-IT.json");
const _temp15 = require("../../intl/dropzone/ja-JP.json");
const _temp16 = require("../../intl/dropzone/ko-KR.json");
const _temp17 = require("../../intl/dropzone/lt-LT.json");
const _temp18 = require("../../intl/dropzone/lv-LV.json");
const _temp19 = require("../../intl/dropzone/nb-NO.json");
const _temp20 = require("../../intl/dropzone/nl-NL.json");
const _temp21 = require("../../intl/dropzone/pl-PL.json");
const _temp22 = require("../../intl/dropzone/pt-BR.json");
const _temp23 = require("../../intl/dropzone/pt-PT.json");
const _temp24 = require("../../intl/dropzone/ro-RO.json");
const _temp25 = require("../../intl/dropzone/ru-RU.json");
const _temp26 = require("../../intl/dropzone/sk-SK.json");
const _temp27 = require("../../intl/dropzone/sl-SI.json");
const _temp28 = require("../../intl/dropzone/sr-SP.json");
const _temp29 = require("../../intl/dropzone/sv-SE.json");
const _temp30 = require("../../intl/dropzone/tr-TR.json");
const _temp31 = require("../../intl/dropzone/uk-UA.json");
const _temp32 = require("../../intl/dropzone/zh-CN.json");
const _temp33 = require("../../intl/dropzone/zh-TW.json");
module.exports = {
  "ar-AE": _temp0,
  "bg-BG": _temp1,
  "cs-CZ": _temp2,
  "da-DK": _temp3,
  "de-DE": _temp4,
  "el-GR": _temp5,
  "en-US": _temp6,
  "es-ES": _temp7,
  "et-EE": _temp8,
  "fi-FI": _temp9,
  "fr-FR": _temp10,
  "he-IL": _temp11,
  "hr-HR": _temp12,
  "hu-HU": _temp13,
  "it-IT": _temp14,
  "ja-JP": _temp15,
  "ko-KR": _temp16,
  "lt-LT": _temp17,
  "lv-LV": _temp18,
  "nb-NO": _temp19,
  "nl-NL": _temp20,
  "pl-PL": _temp21,
  "pt-BR": _temp22,
  "pt-PT": _temp23,
  "ro-RO": _temp24,
  "ru-RU": _temp25,
  "sk-SK": _temp26,
  "sl-SI": _temp27,
  "sr-SP": _temp28,
  "sv-SE": _temp29,
  "tr-TR": _temp30,
  "uk-UA": _temp31,
  "zh-CN": _temp32,
  "zh-TW": _temp33
}